import {
  StyleSheet,
} from 'react-native';
import { ifIphoneX } from 'react-native-iphone-x-helper';

import {
  primaryFont300,
  primaryFont500,
} from './Common';

export default StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 10,
    width: '100%',
    maxWidth: 600,
    padding: 0,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    paddingBottom: 20,
  },
  containerFullScreen: {
    flex: 1,
    paddingHorizontal: 10,
    width: '100%',
    padding: 0,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    paddingBottom: 20,
  },
  containerScrollable: {
    paddingHorizontal: 10,
    width: '100%',
    maxWidth: 600,
    padding: 0,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    paddingBottom: 20,
  },
  containerInputs: {
    flex: 1,
    justifyContent: 'space-evenly',
    alignItems: 'center',
    width: '100%',
    maxWidth: 600,
    paddingHorizontal: 10,
  },
  containerButtons: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignContent: 'space-around',
    ...ifIphoneX({
      paddingBottom: 10,
    }),
  },
  inputContainer: {
    width: '100%',
    maxWidth: 600,
    marginTop: 15,
  },
  inputLabel: {
    margin: 15,
    fontFamily: primaryFont500,
    fontWeight: '500',
    fontSize: 16,
    lineHeight: 20,
    color: '#26272A',
  },
  // disabledInputLabel: {
  //   margin: 15,
  //   fontFamily: primaryFont500,
  //   fontWeight: '500',
  //   fontSize: 16,
  //   lineHeight: 20,
  //   color: '#CCCCCC',
  // },
  inputInputContainer: {
    borderRadius: 8,
    borderBottomWidth: 0,
    overflow: 'hidden',
    backgroundColor: '#F2F2F2',
    marginVertical: 0,
  },
  inputInputContainerError: {
    borderRadius: 8,
    borderBottomWidth: 1,
    overflow: 'hidden',
    backgroundColor: '#F2F2F2',
    borderWidth: 1,
    borderColor: '#E72834',
  },
  inputInput: {
    flex: 1,
    fontFamily: primaryFont300,
    fontWeight: '300',
    fontSize: 14,
    lineHeight: 20,
    color: 'black',
    marginHorizontal: 15,
    padding: 0,
    margin: 0,
    marginVertical: 0,
  },
  inputInputDisabled: {
    flex: 1,
    fontFamily: primaryFont300,
    fontWeight: '300',
    fontSize: 14,
    color: '#F2F2F2',
    marginHorizontal: 15,
    padding: 0,
    margin: 0,
    marginVertical: 0,
  },
  inputIconContainer: {
    backgroundColor: 'transparent',
    marginLeft: 15,
  },
  checkboxContainer: {
    borderWidth: 0,
    borderRadius: 20,
    padding: 20,
    margin: 15,
    backgroundColor: '#F2F2F21C',
  },
  wrapperStyle: {
    justifyContent: 'flex-start',
  },
  checkboxText: {
    fontFamily: primaryFont500,
    fontWeight: '500',
    fontSize: 16,
    lineHeight: 20,
    color: '#26272A',
  },
});
